export const SUPPORTED_LANGUAGES = [
  'en', 'sv', 'fr', // Original
  'de', 'nl', 'no', 'da', // Germanic
  'es', 'pt', 'it', 'ro', // Romance
  'ru', 'pl', 'cs', 'uk', // Slavic
  'zh-CN', 'zh-TW', 'ja', 'ko', 'vi', 'th', 'id', 'hi', // Asian
] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export const LANGUAGE_STORAGE_KEY = 'vb-language';
export const FALLBACK_LANGUAGE: SupportedLanguage = 'en';

export interface LanguageInfo {
  code: SupportedLanguage;
  label: string;
  nativeLabel: string;
}

export const AVAILABLE_LANGUAGES: LanguageInfo[] = [
  // Original
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'sv', label: 'Swedish', nativeLabel: 'Svenska' },
  { code: 'fr', label: 'French', nativeLabel: 'Français' },
  // Germanic
  { code: 'de', label: 'German', nativeLabel: 'Deutsch' },
  { code: 'nl', label: 'Dutch', nativeLabel: 'Nederlands' },
  { code: 'no', label: 'Norwegian', nativeLabel: 'Norsk' },
  { code: 'da', label: 'Danish', nativeLabel: 'Dansk' },
  // Romance
  { code: 'es', label: 'Spanish', nativeLabel: 'Español' },
  { code: 'pt', label: 'Portuguese', nativeLabel: 'Português' },
  { code: 'it', label: 'Italian', nativeLabel: 'Italiano' },
  { code: 'ro', label: 'Romanian', nativeLabel: 'Română' },
  // Slavic
  { code: 'ru', label: 'Russian', nativeLabel: 'Русский' },
  { code: 'pl', label: 'Polish', nativeLabel: 'Polski' },
  { code: 'cs', label: 'Czech', nativeLabel: 'Čeština' },
  { code: 'uk', label: 'Ukrainian', nativeLabel: 'Українська' },
  // Asian
  { code: 'zh-CN', label: 'Chinese (Simplified)', nativeLabel: '简体中文' },
  { code: 'zh-TW', label: 'Chinese (Traditional)', nativeLabel: '繁體中文' },
  { code: 'ja', label: 'Japanese', nativeLabel: '日本語' },
  { code: 'ko', label: 'Korean', nativeLabel: '한국어' },
  { code: 'vi', label: 'Vietnamese', nativeLabel: 'Tiếng Việt' },
  { code: 'th', label: 'Thai', nativeLabel: 'ไทย' },
  { code: 'id', label: 'Indonesian', nativeLabel: 'Bahasa Indonesia' },
  { code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी' },
];
